<div class="booking-customer-main-photo-dialog">
  <div *ngIf="showCropper && preview" class="booking-customer-main-photo-dialog__cropper-wrap">
    <img
      #cropImage
      [src]="preview"
      alt="Обрезка"
      class="booking-customer-main-photo-dialog__cropper-img"
      (load)="onCropImageLoad()"
    />
  </div>
  <div *ngIf="!showCropper && preview" class="booking-customer-main-photo-dialog__preview-wrap">
    <img [src]="preview" alt="Фото профиля" class="booking-customer-main-photo-dialog__preview" />
  </div>
  <div *ngIf="!preview" class="booking-customer-main-photo-dialog__placeholder">
    <i class="pi pi-image"></i>
    <p>Фото не загружено</p>
  </div>

  <div class="booking-customer-main-photo-dialog__actions">
    <input
      type="file"
      #fileInput
      class="booking-customer-main-photo-dialog__file-input"
      accept="image/png,image/jpeg,image/jpg"
      (change)="onFileChange($event.target.files, $event.target)"
    />
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="fileInput.click()" [disabled]="loading || applyLoading">
      {{ preview ? 'Заменить' : 'Загрузить' }}
    </button>
    <button *ngIf="preview" type="button" class="ui-buttons ui-buttons__light-small" (click)="remove()" [disabled]="loading || applyLoading">
      Удалить
    </button>
  </div>
  <p class="txt-caption booking-customer-main-photo-dialog__hint">
    {{ showCropper ? 'Выберите область для фото. Можно менять размер и пропорции рамки.' : 'До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.' }}
  </p>
  <div class="booking-customer-main-photo-dialog__footer">
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onCancel()">Отмена</button>
    <button type="button" class="ui-buttons ui-buttons__blue-small" (click)="onApply()" [disabled]="!isApplyEnabled">
      Применить
    </button>
  </div>
</div>
